//import React from 'react'
import { connect } from 'react-redux'
import  FuelEntry  from '../components/FuelEntry'
import { addFillup } from '../actions'


const mapStateToProps = (state, {params}) => {
	return {...params}
}

const FuelEntryContainer = connect(
  mapStateToProps,
  {onChange:addFillup}
)(FuelEntry)
	

export default FuelEntryContainer


// WEBPACK FOOTER //
// ./src/containers/FuelEntryContainer.js